"use client";

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { getLocaleFromPathname, withLocale } from '@/lib/i18n';
import { getToolUiCopy } from '@/lib/tool-ui-copy';

export default function PDFEditorRedirect() {
  const router = useRouter();
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const ui = getToolUiCopy(locale);
  
  useEffect(() => {
    router.replace(withLocale(locale, '/pdf-to-edit'));
  }, [locale, router]);
  
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p>{ui.redirectingToPdfEditor}</p>
      </div>
    </div>
  );
}
